module.exports = __webpack_public_path__ + "static/media/ios-restaurant.7bc0d43c.svg";